/*
包含n个mutation名称常量
 */
export const ON_HTTP_ERROR = 'onHttpError' 
export const SAVE_USER_INFO = 'saveUserInfo'
export const CURR_AREA_CODE = 'currAreaCode'
export const TOMCAT_INFO = 'tomcatInfo'





// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js